import { render, staticRenderFns } from "./PlaceBeacon.vue?vue&type=template&id=666d61a0&"
import script from "./PlaceBeacon.vue?vue&type=script&lang=js&"
export * from "./PlaceBeacon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports